
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pins/[pinId]",
      function () {
        return require("private-next-pages/pins/[pinId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pins/[pinId]"])
      });
    }
  